import React from "react";
import { FormControl } from "../Controls/FormControl";
import { FormContext } from "./FormContext";
import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";

import styled from "styled-components";

export class ObserableData {
    innerComponent: FormControl;
    context: FormContext;

    constructor(innerComponent: FormControl, context: FormContext) {
        this.innerComponent = innerComponent;
        this.context = context;
    }
}

export class XRuntimeWrapper extends React.Component<ObserableData> {
    render() {
        const valueName = Reflect.get(this.props.innerComponent, "valueName");
        const id = this.props.innerComponent.id;
        if (valueName) {
            return (
                <ObserveState
                    listenTo={this.props.context}
                    control={() => this.renderControl()}
                    properties={[valueName, id]}
                />
            );
        } else {
            return this.props.innerComponent.render();
        }
    }

    renderControl() {
        const id = this.props.innerComponent.id;
        const hideControls = this.props.context.runtimeHideControls;
        if (hideControls.indexOf(id) >= 0) return null;
        const disabledControls = this.props.context.runtimeDisabledControls;
        if (disabledControls.indexOf(id) >= 0) {
            return <StyledFieldSet disabled>{this.props.innerComponent.render()}</StyledFieldSet>;
        }
        return this.props.innerComponent.render();
    }
}

const StyledFieldSet = styled.fieldset`
    border: none;
    margin: 0px;
    padding: 0px;
`;
